import { render } from "./QueryTest.vue?vue&type=template&id=55f48418&scoped=true"
import script from "./QueryTest.vue?vue&type=script&lang=js"
export * from "./QueryTest.vue?vue&type=script&lang=js"

import "./QueryTest.vue?vue&type=style&index=0&id=55f48418&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f48418"]])

export default __exports__